import React, { useContext, useEffect, useRef, useState } from "react";

import { Form, Button, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { t } from "i18next";
const ConfirmPin = ({ show, handelClose, pin, setPin, onSubmit, isLoader }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      countryCode: 91,
      uniqueId: Math.random() * 10000,
    },
  });

  const [passwordType, setPasswordType] = useState("password");
  const togglePassword = (e) => {
    e.preventDefault();
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  return (
    <app-profile-verified-inner
      _ngcontent-serverapp-c8985285=""
      _nghost-serverapp-c421677202=""
      class="ng-tns-c8985285-16 ng-tns-c421677202-17 ng-star-inserted"
    >
      <div
        _ngcontent-serverapp-c421677202=""
        className="pop-get-vcode ng-tns-c421677202-17 ng-trigger ng-trigger-popWrapTriggerAni active ng-star-inserted"
      >
        <a
        onClick={() => handelClose()}
          _ngcontent-serverapp-c421677202=""
          className="btn-closed ng-tns-c421677202-17"
          style={{
            maskImage:
              'url("https://img.s303ix6.com/s6/h5/assets/images/icon-set/base/icon-close.svg?v=1760442828735")',
          }}
        />
        <Form
          onSubmit={handleSubmit(onSubmit)}
          _ngcontent-serverapp-c421677202=""
          className="ng-tns-c421677202-17 ng-untouched ng-pristine ng-invalid"
        >
          <div
            _ngcontent-serverapp-c421677202=""
            className="menu-box ng-tns-c421677202-17"
          >
         
            <div
              _ngcontent-serverapp-c684031653
              className="title ng-tns-c684031653-19"
            >
              <h2
                _ngcontent-serverapp-c684031653
                className="ng-tns-c684031653-19"
              >
                <span
                  style={{ width: "auto" }}
                  _ngcontent-serverapp-c684031653
                  className="ng-tns-c684031653-19"
                >
                  Password
                </span>
              </h2>
            </div>
            <div
              _ngcontent-serverapp-c684031653
              className="input-group money ng-tns-c684031653-19"
            >
              <input
                _ngcontent-serverapp-c684031653
                className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                type="text"
                placeholder="Enter password"
                {...register("verificationCode", {
                  required: "Please enter password",
                })}
              />
              {errors.verificationCode && errors.verificationCode.message && (
                <div
                  _ngcontent-serverapp-c3110418782
                  className="error-message-box ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c3110418782
                    className="error-message"
                  >
                    <span _ngcontent-serverapp-c3110418782>
                      {errors.verificationCode.message}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div
              _ngcontent-serverapp-c684031653
              className="member-content ng-tns-c684031653-19 ng-star-inserted"
            >
              <div
                _ngcontent-serverapp-c684031653
                className="button btn-primary ng-tns-c684031653-19"
                style={{ marginLeft: "0", marginRight: "0", width: "100%" }}
              >
                <button
                  type="submit"
                  className="ng-tns-c684031653-19"
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    color: "white",
                    fontWeight: "600",
                    fontSize: "20px",
                  }}
                >
                  {t("Submit")}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div
        _ngcontent-serverapp-c421677202=""
        className="pop-bg ng-tns-c421677202-17 ng-trigger ng-trigger-popBgTriggerAni ng-star-inserted"
        style={{
          display: "block",
        }}
      />
    </app-profile-verified-inner>
  );
};

export default ConfirmPin;
